export default "__VITE_ASSET__50bcaa5f__"